export enum ReservedPages {
  NOT_FOUND = '404',
  INTERNAL_SERVER_ERROR = '500',
  SEARCH = 'search',
  PRODUCTS = 'products',
  LOGIN = 'login',
  REGISTER = 'register',
  CONTACT_US = 'contact-us',
}
